// when everything is ready call this
import { Elm } from "../Main.elm";

if (process.env.NODE_ENV === "development" && process.env) {
  Object.entries(process.env).map((v) => {
    console.log("%c%s %c%s", "color: green", v[0], "color: red", v[1]);
  });
}

export const flags = {
  version: process.env.ELM_APP_VERSION,
  initialSeed: Math.floor(Math.random() * 0x0fffffff),
  windowWidth: window.innerWidth,
  urlPrefix: process.env.ELM_APP_SC_BASE_URL,
  urlFabric: process.env.ELM_APP_FABRIC_BASE_URL,
  logoPath: require("../media/sctv-logo.png").default,
  sctvLogoWhite: require("../media/sctv-logo-white.png").default,
  primeroedgeFeatureUrl: require("../media/primeroedge-feature.png").default,
  customizeFeatureUrl: require("../media/customize-feature.png").default,
  remoteMgmtFeatureUrl: require("../media/remote-mgmt-feature.png").default,
  syncFeatureUrl: require("../media/sync-feature.png").default,
  setupDeviceFeatureUrl: require("../media/setup-device-feature.png").default,
  welcomeSideChromeUrl: require("../media/welcome-side-chrome.png").default,
  welcomeSideAppleUrl: require("../media/welcome-side-apple.png").default,
  templateAura: require("../media/Template/Aura.svg").default,
  templateCosmos: require("../media/Template/Cosmos.svg").default,
  templateSingularity: require("../media/Template/Singularity.svg").default,
  templateEthereal: require("../media/Template/Ethereal.svg").default,
  templateHelios: require("../media/Helios/thumbnail.svg").default,
  newDeviceInitStepUrl: require("../media/new-device-initial-setup.png")
    .default,
  year: `${new Date().getFullYear()}`,
};

export const app = Elm.Main.init({
  root: document.getElementById("root"),
  flags: flags,
});
